export function buildUpdatePayloadFromRow(row: any, extra: any = {}) {
  const payload: any = {
    ...row,
    ...extra,
  };

  Object.entries(row).forEach(([key, value]) => {
    if (value && typeof value === "object" && "id" in (value as any)) {
      const idKey = `${key}Id`;

      if (payload[idKey] == null) {
        payload[idKey] = (value as any).id;
      }
    }
  });

  delete payload.deleted;
  delete payload.createdTime;
  delete payload.editedTime;
  delete payload.dictionaryCode;

  return payload;
}
